import { StoreState } from "../../../../apps/containers/AppContainer/StoreState";
import BarrelActions from "../../../../apps/data/barrel/BarrelActions";
import BarrelHelpers from "../../../../apps/data/barrel/BarrelHelpers";
import ScreenHelpers from "../../../../apps/data/screen/ScreenHelpers";
import SidebarTabType from "../../../../foundation/model/SidebarTabType";

import { DispatchProps, StoreProps, OwnProps } from "./ScreenCardCommentsBadgeProps";

export function mapStateToProps(_: StoreState, { screenId }: OwnProps): StoreProps {
    const barrel = BarrelHelpers.getBarrel();

    return {
        screenDots: ScreenHelpers.getAllDotsOfVariantGroupOfScreen({
            pid: barrel?._id,
            sid: screenId
        })
    };
}

export function mapDispatchToProps(): DispatchProps {
    return {
        onClick() {
            BarrelActions.setSelectedSidebarTab(SidebarTabType.Comments);
        }
    };
}
